/** Defines a resize handle position. */
export enum ResizeHandlePosition {
  Left = "left",
  Right = "right"
}

/** Defines a resize handle event. */
export interface ResizeHandleSizeChangedEvent {
  /** The new size value (in pixels) emited by the resize handle. */
  value: number;
}
